<template>
  <div>
    <div :class="time < 0.2 * testtime ? 'timeouting' : ''" class="timer">
      <div class="timer-icon p-1">
        <b-icon-clock font-scale="1.1"></b-icon-clock> 
      </div>
      <div class="time-text p-1">
        <span>{{ counter }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: ["forcesubmit", "timeer"],
  data() {
    return {
      time: this.timeer ? this.timeer : this.inittime,
      counter: ``,
      alreadysubmitted: false,
      interval: null,  // Store interval reference
      updateInterval: 0
    };
  },
  created() {
    this.startTimer();

    this.time = this.timeer ? this.timeer : this.inittime
    // console.log(this.time)
    // console.log(this.inittime, "--", this.timeer)
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    forcesubmit(newValue) {
      if (newValue) {
        this.time = 0;
      }
    },
    time(newTime) {
      if (newTime <= 0 && !this.alreadysubmitted) {
        this.handleAutoSubmit();
      }
    },
  },
  methods: {
    ...mapActions("exam", ["updatetimeconfig", "setAlreadysub", "destroyAlreadysub"]),

    startTimer() {
      this.interval = setInterval(this.countdown, 1000);
    },

    countdown() {
      if (this.time <= 0) {
        this.counter = "00:00";
        return;
      }

      const hours = Math.floor(this.time / 3600);
      const minutes = Math.floor((this.time % 3600) / 60);
      let seconds = this.time % 60;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      this.counter = hours > 0 ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
      this.time = Number(this.time) - 1;

      // console.log(this.inittime, "--", this.timeer)
      // console.log(this.time)

      this.updateInterval++;

      // Update Vuex only every 2 minutes (120 seconds)
      if (this.updateInterval >= 120) {
        this.updateInterval = 0; // Reset counter
        if (!this.timeer) {
          this.updatetimeconfig(this.time);
        }
      }
    },

    handleAutoSubmit() {
      try {
        if (!this.alreadysub) {
          this.updatetimeconfig(this.time);
          this.autosubmit();
          this.setAlreadysub();
        }
      } catch (err) {
        this.destroyAlreadysub();
      }
    },

    autosubmit() {
      this.$emit("autosubmit");
    },
  },
  computed: {
    ...mapState({
      inittime: (state) => state.exam.start_config.total_time,
      testtime: (state) => state.exam.testtime,
      submitted: (state) => state.exam.submitted,
      alreadysub: (state) => state.exam.alreadysub,
    }),
  },
};
</script>

<style scoped>
.timer {
  display: flex;
  color: #00377b;
  font-size: 1.7rem;
  font-weight: bolder;
}
.timer-icon {
  display: block;
  width: 50%;
}
.timer-text {
  width: 50%;
}

@media (max-width: 999px) {
  .timer {
    font-size: 1.3rem;
  }
}

.timeouting {
  color: red;
}
</style>
